import React from 'react';
import SkeletonLoadingBox from '../common/SkeletonLoadingBox';

function ProductVariationListItemSkeleton(props) {
    return (
        <div className='data-table__tr products-data-table-helper__row products-data-table-helper__row--loading'>
            <div className='data-table__td products-data-table-helper__image'>
                <div className='products-data-table-helper__info-wrapper'>
                    <SkeletonLoadingBox
                        width='100%'
                        style={{ paddingBottom: '100%' }}
                    />
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__info'>
                <span className='data-table__info data-table__info--default'>
                    <div className='mini-hint'>
                        <SkeletonLoadingBox width={70} height={19} />
                    </div>
                    <div className='product__general-title'>
                        <SkeletonLoadingBox width={130} height={25} />
                    </div>
                </span>
            </div>
            <div className='data-table__td products-data-table-helper__label'>
                <div className='products-data-table-helper__info-wrapper' />
            </div>
            <div className='data-table__td products-data-table-helper__qty'>
                <div className='products-data-table-helper__info-wrapper'>
                    <div>
                        <SkeletonLoadingBox width={140} height={41} />
                        <span className='products-data-table__input-explanation'>
                            <SkeletonLoadingBox width={130} height={12} />
                        </span>
                    </div>
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__price'>
                <div className='products-data-table-helper__info-wrapper'>
                    <div>
                        <span className='products-data-table__price products-data-table__price--crossed'>
                            <SkeletonLoadingBox width={25} height={12} />
                        </span>
                        <span className='products-data-table__price'>
                            <SkeletonLoadingBox width={60} height={16} />
                        </span>
                    </div>
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__action'>
                <div className='products-data-table-helper__info-wrapper'>
                    <div>
                        <SkeletonLoadingBox width={150} height={40} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductVariationListItemSkeleton;
